export const GET_SECTORS = 'app/store/sector/GET_SECTORS';
export const GET_SECTORS_SUCCESS = 'app/store/sector/GET_SECTORS_SUCCESS';
export const GET_SECTORS_ERROR = 'app/store/sector/GET_SECTORS_ERROR';
